import { observer } from 'mobx-react';
import { Checkbox, Flex, Loader, Switch, Table, Text } from '@mantine/core';
import classes from '../../../../sharedStyles/InfoCard.module.css';
import { useTranslation } from 'react-i18next';
import { BaseLayout } from '../../navigation';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { useRaffleWinnersStore } from './RaffleWinnersStore';
import { ConfirmCollectionModal } from './ConfirmCollectionModal';

export const RaffleWinners = observer(() => {
  const raffleWinnersStore = useRaffleWinnersStore();
  const { t } = useTranslation('organizer-dashboard');

  useEffect(() => {
    raffleWinnersStore.loadWinners();
  }, [raffleWinnersStore]);

  return (
    <BaseLayout>
      <>
        <Flex
          direction="column"
          maw={1100}
          gap={20}
          bg="#fff"
          p={40}
          className={classes.borderRadius}
        >
          <Flex align="center">
            <Text fw="500" size="28px" lh="24px">
              {t('RaffleWinners.Title')}
            </Text>
            <Switch
              ml="auto"
              label={t('RaffleWinners.ShowPaidOut')}
              labelPosition="left"
              checked={raffleWinnersStore.showCollected}
              onChange={() => raffleWinnersStore.toggleShowCollected()}
            />
          </Flex>

          {raffleWinnersStore.isLoading ? (
            <Flex justify="center" py={40}>
              <Loader />
            </Flex>
          ) : (
            <Table>
              <Table.Thead bg="#F1F0E89999" fw="500" lh="24px">
                <Table.Tr>
                  <Table.Td>{t('RaffleWinnerTable.Columns.Name')}</Table.Td>
                  <Table.Td>
                    {t('RaffleWinnerTable.Columns.UserSearchID')}
                  </Table.Td>
                  <Table.Td>{t('RaffleWinnerTable.Columns.Cohort')}</Table.Td>
                  <Table.Td>{t('RaffleWinnerTable.Columns.Location')}</Table.Td>
                  <Table.Td>{t('RaffleWinnerTable.Columns.Prize')}</Table.Td>
                  <Table.Td>{t('RaffleWinnerTable.Columns.EndDate')}</Table.Td>
                  <Table.Td>{t('RaffleWinnerTable.Columns.PayedOut')}</Table.Td>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {raffleWinnersStore.filteredWinners.map((winner) => {
                  const isCollected = winner.collectedAt !== null;
                  return (
                    <Table.Tr key={`${winner.raffleId}-${winner.userId}`}>
                      <Table.Td>{winner.fullname}</Table.Td>
                      <Table.Td>{winner.userSearchID}</Table.Td>
                      <Table.Td>{winner.cohortId ?? '-'}</Table.Td>
                      <Table.Td>
                        {winner.dispensaries.length > 0 ? (
                          <Flex direction="column" gap={4}>
                            {winner.dispensaries.map((dispensary, index) => (
                              <Text key={index}>{dispensary}</Text>
                            ))}
                          </Flex>
                        ) : (
                          '-'
                        )}
                      </Table.Td>
                      <Table.Td>{winner.prize}</Table.Td>
                      <Table.Td>
                        {DateTime.fromJSDate(winner.endDate).toFormat(
                          'dd.MM.yyyy',
                        )}
                      </Table.Td>
                      <Table.Td>
                        <Checkbox
                          checked={isCollected}
                          disabled={isCollected}
                          onChange={() =>
                            raffleWinnersStore.selectWinner(winner)
                          }
                        />
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
                {raffleWinnersStore.filteredWinners.length === 0 && (
                  <Table.Tr>
                    <Table.Td colSpan={7} ta="center" py={20}>
                      {t('RaffleWinners.NoWinners')}
                    </Table.Td>
                  </Table.Tr>
                )}
              </Table.Tbody>
            </Table>
          )}
        </Flex>

        <ConfirmCollectionModal />
      </>
    </BaseLayout>
  );
});
